import React, { ChangeEvent, useContext, useState, useEffect } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
// import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFLegend from 'src/components/controls/tempRHFControls/RHFLegend';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
// import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';
import State from 'src/models/State';
import Acknowledgement from 'src/models/leasing/Acknowledgement';
// import AcknowledgementType from 'src/models/leasehold/AcknowledgementType';
import AcknowledgementType from 'src/models/leasing/AcknowledgementType';
// import CorporateAck from './Acknowledgments/CorporateAck';
// import IndividualAck from './Acknowledgments/IndividudalAck';
// import AttorneyInFactAck from './Acknowledgments/AttorneyInFactAck';
// import LLCAck from './Acknowledgments/LLCAck';
import ShortFormAck from './Acknowledgments/Short-FormAck';
import { useForm } from 'react-hook-form';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import SignatureBlock from 'src/models/leasing/SignatureBlock';
import AnimateHeight from 'react-animate-height';
// import SignatureBlock from 'src/models/leasing/SignatureBlock';
import Button from 'src/components/controls/forms/redesign/FormButton';
// import Button from 'src/components/controls/forms/redesign/FormButton';
import SignatureCard from './SignatureBlockComponents/SignatureCard.redesign';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';

interface IAcknowledgementDialog {
    acknowledgement?: Acknowledgement;
    states?: State[];
    acknowledgementTypes?: AcknowledgementType[];
    newAcknowledgement?: boolean;
    olderVersions?: boolean;
    refreshLease?: (data: boolean) => void;
    invoiceableLookupId?: number;
    hideDialog?: () => void;
}

const AcknowledgementDialog = (props: IAcknowledgementDialog) => {
    const { register, errors, handleSubmit, reset } = useForm();
    const appContext = useContext<IAppContextState>(AppContext);
    const { post, put, response, del } = useFetch();

    const [ackType, setAckType] = useState<number>(undefined);
    const [showAck, setShowAck] = useState<string | number>('auto');
    const [signatures, setSignatures] = useState<SignatureBlock[]>([]);
    const [availableTypes, setAvailableTypes] = useState<Array<AcknowledgementType>>([]);
    const [selectedState, setSelectedState] = useState<number>(undefined);
    const [selectedCounty, setSelectedCounty] = useState<string>(undefined);

    useEffect(() => {
        setShowAck(props.olderVersions ? 0 : 'auto');
    }, []);

    useEffect(() => {
        if (!!props?.acknowledgement && !props?.newAcknowledgement) {
            prepAckData();
        }
    }, [props.acknowledgement, props.newAcknowledgement]);

    useEffect(() => {
        if (!!props?.acknowledgementTypes) {
            availableAckTypes();
        }
    }, [props.acknowledgementTypes]);

    const prepAckData = () => {
        let prepData: Acknowledgement = {
            id: props.acknowledgement.id,
            stateId: props.acknowledgement.stateId,
            contractLookupId: props.acknowledgement.contractLookupId,
            typeId: props.acknowledgement.typeId,
            text: props.acknowledgement.text,
            signatureBlocks: props.acknowledgement.signatureBlocks,
        };

        setSignatures(props?.acknowledgement?.signatureBlocks);

        reset(prepData);
    };

    const availableAckTypes = () => {
        let newTypes: AcknowledgementType[] = [];
        let defaultTypes: number[] = [1, 3, 8, 13];

        defaultTypes.forEach((dt) => {
            let type: AcknowledgementType = !!props?.acknowledgementTypes ? props.acknowledgementTypes.find((at) => at.id === dt) : undefined;

            if (!!type) {
                newTypes.push(type);
            }
        });

        setAvailableTypes(newTypes);
    };

    const handleAckTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
        let value: number = parseInt(e.target.value + '', 10);
        setAckType(value);
    };

    const acknowledgementGenerator = (body: string) => {
        let template: string[] = [
            `STATE OF ${!!getSelectedState(selectedState) ? getSelectedState(selectedState)?.toUpperCase() : '________________________'}\r\n\r\n`,
            `COUNTY OF ${!!selectedCounty ? selectedCounty.toUpperCase() : '________________________'}\r\n\r\n\r\n`,
            'userInput',
            '\r\n\r\n\r\n________________________________________\r\nNotary Public\r\n\r\n',
            'Print Name _______________________________________\r\n\r\n',
            'My Commission expires: ________________________\r\n\r\n',
            'Commission Number: ________________________',
        ];

        template[2] = body;

        let finalAck: string = template.join('');

        return finalAck;
    };

    const addSignature = () => {
        if (showAck === 'auto') {
            setShowAck(0);
        }

        setSignatures(signatures.concat([{ id: 0, acknowledgementId: 0, ownerName: '' }]));
    };

    const deleteSignature = async (index: number) => {
        let signatureFromAck: SignatureBlock | undefined = props.acknowledgement?.signatureBlocks[index];
        if (!!signatureFromAck) {
            if (!!signatureFromAck) {
                const result = await del(
                    `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contractGeneration/signature/${signatureFromAck.id}`
                );
    
                if (response.ok) {
                    console.log('Successfully Delete Signagture Block', result);
                    props?.refreshLease(true);
                    props?.hideDialog();
                } else {
                    console.log('Failed to Delete Signature from Acknowledgment!');
                }
            } else {
                setSignatures((prev) => {
                    let newSignatures = prev.filter((s, sIndex) => sIndex !== index);
                    return newSignatures;
                });
            }
        } else {
            window.alert(`Delete failed. Invalid signature selected.`);
        }
    };

    const displaySignatures = () => {
        if (signatures?.length > 0) {
            return signatures.map((signature: SignatureBlock, index: number) => {
                return (
                    <SignatureCard
                        key={index}
                        index={index}
                        register={register}
                        ackType={!!props?.acknowledgementTypes ? props?.acknowledgementTypes : []}
                        // typeSelected={!!ackType && ackType}
                        deleteCard={deleteSignature}
                    />
                );
            });
        } else {
            return <div>No Signature for this Acknowledgement</div>;
        }
    };

    const createNewAcknowledgment = async (data: Acknowledgement) => {
        if (!!props.invoiceableLookupId) {
            await post(
                `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contractGeneration/acknowledgements`,
                data
            );
    
            if (response.ok) {
                props.refreshLease(true);
                setTimeout(() => {
                    props.hideDialog();
                }, 500);
            } else {
                window.alert('Create Acknowledgment failed.');
            }
        } else {         
            console.log('Invalid Invoiceable Lookup Id:', props.invoiceableLookupId);
            window.alert('Create Acknowledgment failed.');
        }
    };

    const updateAcknowledgement = async (data: Acknowledgement) => {
        await put(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/contractGeneration/acknowledgements`, data);

        if (response.ok) {
            props.refreshLease(true);
            props.hideDialog();
        } else {
            window.alert('Update Acknowledgment failed.');
        }
    };

    const finalizeData = (data: Acknowledgement) => {
        data.id = data.id ? parseInt(data.id + '', 10) : 0;
        data.stateId = !!data.stateId ? parseInt(data.stateId + '', 10) : null;
        data.typeId = !!data.typeId ? parseInt(data.typeId + '', 10) : null;
        data.contractLookupId = !!data.contractLookupId ? parseInt(data.contractLookupId + '', 10) : null;
        data.text = !!data.text ? data.text : '';

        if (!props?.newAcknowledgement) {
            data.id = !!props.acknowledgement ? props?.acknowledgement?.id : 0;
            data.contractLookupId = !!props.acknowledgement ? props?.acknowledgement?.contractLookupId : 0;
        }

        if (data?.signatureBlocks?.length > 0) {
            data.signatureBlocks.map((sb) => {
                sb.id = !!sb.id ? parseInt(sb.id + '', 10) : 0;
                sb.acknowledgementId = !!data.id ? data.id : 0;
                sb.ownerName = !!sb.ownerName ? sb.ownerName : '';
                sb.title = !!sb.title ? sb.title : '';
            });
        } else {
            data.signatureBlocks = [];
        }

        return data;
    };

    const onSubmit = (data: Acknowledgement) => {
        let newData = finalizeData(data);

        if (props?.newAcknowledgement && newData.id === 0) {
            let acknowledgementText = acknowledgementGenerator(data.text);
            newData.text = acknowledgementText;
            newData.invoiceableLookupId = props.invoiceableLookupId;
            createNewAcknowledgment(newData);
        }

        if (!props?.newAcknowledgement) {
            let updatedAck = finalizeData(newData);
            updateAcknowledgement(updatedAck);
        }
    };

    const getSelectedState = (id: number): string | undefined => {
        return props?.states?.find((s) => s.id === id)?.name;
    };

    return (
        <Dialog title={!!props?.newAcknowledgement ? 'New Acknowledgment' : 'Update Acknowledgment'}>
            <div style={{ width: '25vw', maxHeight: '80vh', overflowY: 'scroll'}}>
                <form onSubmit={handleSubmit(onSubmit)} id="acknowledgementForm">
                    <div style={{ display: props.olderVersions ? '' : 'none' }}>
                        {!!props?.newAcknowledgement ? (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'center' }}>
                                <div style={{ width: '150px' }}>
                                    <RHFSelect
                                        label="Acknowledgment Type"
                                        name="typeId"
                                        options={
                                            !!availableTypes
                                                ? availableTypes.map((ackT) => {
                                                    return { value: ackT.id, label: `${ackT.name}` };
                                                })
                                                : []
                                        }
                                        onChange={handleAckTypeChange}
                                        register={register}
                                        errors={errors}
                                    />
                                </div>
                                <div style={{ width: '150px' }}>
                                    <RHFSelect
                                        label="State"
                                        name="stateId"
                                        options={
                                            props?.states
                                                ? props?.states.map((s) => {
                                                    return { value: s.id, label: `${s.name}` };
                                                })
                                                : []
                                        }
                                        onChange={(e: React.FormEvent<HTMLSelectElement>) => setSelectedState(parseInt(e.currentTarget.value, 10))}
                                        register={register}
                                        errors={errors}
                                    />
                                </div>
                                <div style={{ width: '150px' }}>
                                    <RHFInputBox
                                        label={'County'}
                                        name={'countyName'}
                                        onChange={(e: React.FormEvent<HTMLInputElement>) => setSelectedCounty(e.currentTarget.value)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem', justifyContent: 'flex-start' }}>
                                <div style={{ width: '150px' }}>
                                    <RHFSelect
                                        label="Acknowledgment Type"
                                        name="typeId"
                                        options={
                                            !!availableTypes
                                                ? availableTypes.map((ackT) => {
                                                    return { value: ackT.id, label: `${ackT.name}` };
                                                })
                                                : []
                                        }
                                        onChange={handleAckTypeChange}
                                        register={register}
                                        errors={errors}
                                    />
                                </div>
                            </div>
                        )}
                        <AnimateHeight
                            duration={500}
                            height={showAck}
                            children={
                                <ShortFormAck
                                    selectedState={getSelectedState(selectedState)}
                                    selectedCounty={selectedCounty}
                                    register={register}
                                    ackType={ackType}
                                    newAcknowledgement={props?.newAcknowledgement}
                                />
                            }
                        />
                        {/*<div>
                        <ShortFormAck register={register} ackType={ackType} newAcknowledgement={props?.newAcknowledgement}/>
                    </div>*/}
                    </div>
                    <div style={{ marginTop: '2rem', display: props.olderVersions ? 'flex' : 'none', gap: '2rem' }}>
                        <Button
                            text={showAck === 'auto' ? 'Hide Acknowledgment' : 'Show Acknowledgment'}
                            onClick={() => setShowAck(showAck === 'auto' ? 0 : 'auto')}
                        />

                        {/*<button type="submit" form="acknowledgementForm">
                            Submit
                        </button>*/}
                    </div>
                    <div style={{ marginTop: '1rem' }}>
                        <RHFLegend title="Signature Blocks" />
                        <div style={{ maxHeight: '20vh', overflow: 'auto' }}>{displaySignatures()}</div>
                        <div style={{ marginTop: '3rem' }}>
                            <Button text="Add Signature" onClick={addSignature} />
                        </div>
                    </div>
                    <div style={{ marginTop: '3rem' }}>
                        <button
                            type="submit"
                            form="acknowledgementForm"
                            style={{ padding: '1rem', backgroundColor: '#6393c1', color: 'white', border: 'none' }}
                        >
                            Submit
                        </button>
                    </div>
                </form>
            </div>
        </Dialog>
    );
};

export default AcknowledgementDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/AcknowledgementDialog.tsx